export default function TranslateUserStatus(status: string) {
  switch (status) {
    case 'CONFIRMED':
      return 'CONFIRMADO'
    case 'FORCE_CHANGE_PASSWORD':
      return 'PENDIENTE PRIMER INGRESO'
    default:
      return ''
  }
}
